import { getLoginData } from '@ami/react/core';
import { appConfig } from '@ami/react/core';
import {
  isAmiUserAuthorizedToManageQuotes,
  isAmiUserAuthorizedToAcceptQuotes,
} from './amiPermissions';

function isUserAuthorizedToManageQuotesInDealerBranch(
  dealerGroupId,
  dealerBranchId
) {
  if (appConfig.isManagementApp) return isAmiUserAuthorizedToManageQuotes();

  const loginData = getLoginData();
  if (!loginData) return false;

  if (loginData.userData.dealerSettings.dealerGroupId !== dealerGroupId) return false;
  if (loginData.userData.dealerSettings.isAdmin) return true;
  return loginData.userData.dealerSettings.dealerBranches.some(
    (s) => s.dealerBranchId === dealerBranchId && s.manageQuotes
  );
}

function isUserAuthorizedToAcceptQuotesInDealerBranch(
  dealerGroupId,
  dealerBranchId
) {
  if (appConfig.isManagementApp) return isAmiUserAuthorizedToAcceptQuotes();

  const loginData = getLoginData();
  if (!loginData) return false;

  if (loginData.userData.dealerSettings.dealerGroupId !== dealerGroupId) return false;
  if (loginData.userData.dealerSettings.isAdmin) return true;
  return loginData.userData.dealerSettings.dealerBranches.some(
    (s) => s.dealerBranchId === dealerBranchId && s.acceptQuotes
  );
}

function isUserDealerAdministrator() {
  if (appConfig.isManagementApp) return false;
  const loginData = getLoginData();
  if (!loginData) return false;

  return loginData.userData.dealerSettings.isAdmin;
}

export {
  isUserAuthorizedToManageQuotesInDealerBranch,
  isUserAuthorizedToAcceptQuotesInDealerBranch,
  isUserDealerAdministrator
};
